import React, { useEffect, useState } from "react";

const WIDGET_URL = "https://bere-plus-widget.netlify.app/bere-plus-widget.js";

export default function WidgetLoader({
  containerId = "bere-plus--widget-container",
  widgetProps = {}, // user configuration { ID | INTENT | PLAN }
}) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let script;

    // Ensure container exists
    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`Widget container #${containerId} not found`);
      setError(`Container #${containerId} not found`);
      return;
    }

    // Avoid loading multiple times
    if (window.WEB_CDN_BERE_PLUS_WIDGET?.__loaded) {
      console.log(
        "⚡ Widget already loaded, initializing again with new props..."
      );
      window.WEB_CDN_BERE_PLUS_WIDGET.initWidget(containerId, widgetProps);
      setLoaded(true);
      return;
    }

    // Create script element
    script = document.createElement("script");
    script.src = WIDGET_URL;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      const widget = window.WEB_CDN_BERE_PLUS_WIDGET;
      if (widget && typeof widget.initWidget === "function") {
        try {
          widget.initWidget(containerId, widgetProps);
          widget.__loaded = true; // mark widget as loaded globally
          console.log("✅ Widget initialized successfully");
          setLoaded(true);
        } catch (e) {
          console.error("🔥 Error initializing widget:", e);
          setError(e.message);
        }
      } else {
        console.error(
          "❌ WEB_CDN_BERE_PLUS_WIDGET not found on window after script load"
        );
        setError("Widget global not found after script load");
      }
    };

    script.onerror = (e) => {
      console.error("Failed to load widget script:", e);
      setError("Failed to load widget script");
    };

    document.body.appendChild(script);
    // Cleanup
    return () => {
      if (script) document.body.removeChild(script);
    };
  }, [containerId, widgetProps]);

  return (
    <>
      <div id={containerId} />
      {!loaded && !error && <p>Loading widget...</p>}
      {/* {error && <p style={{ color: "red" }}>Widget Error: {error}</p>} */}
    </>
  );
}
